import prd from './environment.prd';
import qa from './environment.qa';
import dev from './environment.dev';
import local from './environment.local';

let environment = prd;

if (window.location.hostname.includes('localhost')) {
    environment = dev;
} else if (window.location.hostname.includes('dev')) {
    environment = dev;
} else if (window.location.hostname.includes('qa')) {
    environment = qa;
}

export default environment;
